'use strict';

module.exports = function (ngModule) {
    // styling
    require('./assets')();
    // services
    require('./services/index.ts')(ngModule);
    // routes
    require('./routes')(ngModule);
}


/** WEBPACK FOOTER **
 ** ./src/system/index.js
 **/